import { render, staticRenderFns } from "./grid-button-section.vue?vue&type=template&id=00652b79&scoped=true"
import script from "./grid-button-section.vue?vue&type=script&lang=js"
export * from "./grid-button-section.vue?vue&type=script&lang=js"
import style0 from "./grid-button-section.vue?vue&type=style&index=0&id=00652b79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00652b79",
  null
  
)

export default component.exports